import type { ReactNode } from 'react';
import { LayoutGrid, List, Table2 } from 'lucide-react';
import { DataTable, type DataTableProps } from './Table';
import { Button } from './Button';
import { useCollectionView } from './tablePreferences';

/** Keep an existing custom card layout and its handlers while offering the shared list/table. */
export function CollectionViews<T>({ grid, ...props }: Omit<DataTableProps<T>, 'view' | 'defaultView'> & { grid: ReactNode }) {
  const [view, setView] = useCollectionView(props.caption, 'grid');
  return <>
    <div className="collection-toolbar"><span>{props.caption}</span><div className="collection-switch" role="group" aria-label={`${props.caption} view`}>
      {(['grid', 'list', 'table'] as const).map(mode => <Button key={mode} size="sm" variant={view === mode ? 'secondary' : 'ghost'} aria-pressed={view === mode} icon={mode === 'grid' ? <LayoutGrid size={16} /> : mode === 'list' ? <List size={16} /> : <Table2 size={16} />} onClick={() => setView(mode)}>{mode === 'grid' ? 'Grid' : mode === 'list' ? 'List' : 'Table'}</Button>)}
    </div></div>
    {view === 'grid' ? grid : <DataTable {...props} view={view} />}
  </>;
}
